export const tokenText = "authToken"
export const getToken = () => localStorage.getItem(tokenText)
export const setToken = (value) => localStorage.setItem(tokenText, value)
export const removeToken = () => localStorage.removeItem(tokenText)

export const originalTokenText = "originalAuthToken"
export const getOriginalToken = () => localStorage.getItem(originalTokenText)
export const setOriginalToken = (value) => localStorage.setItem(originalTokenText, value)
export const removeOriginalToken = () => localStorage.removeItem(originalTokenText)

export const originalAuthUserText = "originalAuthUser"

export const getOriginalAuthUser = () => {
  const rawValue = localStorage.getItem(originalAuthUserText)

  if (!rawValue) {
    return null
  }

  try {
    return JSON.parse(rawValue)
  } catch (error) {
    localStorage.removeItem(originalAuthUserText)
    return null
  }
}

export const setOriginalAuthUser = value =>
  localStorage.setItem(originalAuthUserText, JSON.stringify(value))

export const removeOriginalAuthUser = () => localStorage.removeItem(originalAuthUserText)

export const lastVisitedPathText = "lastVisitedPath"

export const getLastVisitedPath = () => {
  const rawValue = localStorage.getItem(lastVisitedPathText)

  if (!rawValue) {
    return null
  }

  try {
    return JSON.parse(rawValue)
  } catch (error) {
    localStorage.removeItem(lastVisitedPathText)
    return null
  }
}

export const setLastVisitedPath = ({ pathname, search = "" }) =>
  localStorage.setItem(lastVisitedPathText, JSON.stringify({ pathname, search }))

export const removeLastVisitedPath = () => localStorage.removeItem(lastVisitedPathText)
